import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { FirebaseProvider } from "./context/Firebase";
// import "../node_modules/flowbite/dist/flowbite";
// import "flowbite";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FirebaseProvider>
      <App/>
    </FirebaseProvider>
  </React.StrictMode>
);
